import { useApolloClient } from '@apollo/client';
import type { PageProps } from 'gatsby';
import { navigate } from 'gatsby';
import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import PageLoader from '@components/PageLoader';

import * as ROUTES from '@constants/routes';

import { useSnackbar } from '@hooks/useSnackbar';

const messages = defineMessages({
  success: {
    id: 'deviceIntegrator.success',
    defaultMessage: 'Successfully connected health device',
  },
  fail: {
    id: 'deviceIntegrator.fail',
    defaultMessage: 'Failed to connect health device. Please try again later.',
  },
});

/**
 * Page that handles terra auth response
 */
export default function DeviceIntegratorResult({ params }: PageProps) {
  const client = useApolloClient();
  const { enqueueSnackbar } = useSnackbar();

  const { formatMessage } = useIntl();

  useEffect(() => {
    async function handleIntegratorResult() {
      if (params.result === 'success') {
        // Delete all listTerraConnections queries so that listTerraConnections is refetched
        client.cache.evict({
          id: 'ROOT_QUERY',
          fieldName: 'listTerraConnections',
        });
        enqueueSnackbar({
          message: formatMessage(messages.success),
          variant: 'success',
        });
      } else {
        enqueueSnackbar({
          message: formatMessage(messages.fail),
          variant: 'error',
        });
      }
      navigate(ROUTES.DEVICES);
    }
    handleIntegratorResult();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <PageLoader />;
}
